// Kumpulan dari URL List FE
import userGroup from 'App/Screens/SubModules/UserGroup/urlList'

export default {
  ...userGroup,
}